export default `#ifndef PROJECTION_CONSTANTS
#define PROJECTION_CONSTANTS

#define PI 3.141592653589793
#define DEG_TO_RAD 0.017453292519943295
#define RAD_TO_DEG 57.29577951308232
#define MERCATOR_LAT_LIMIT 85.0
#define CYLINDRICAL_EQUAL_AREA_SCALE 1.2792006328649603
#define AZIMUTHAL_CLIP_ANGLE_RAD 3.0194196059501588

#define PROJ_GLOBE 0
#define PROJ_EQUIRECTANGULAR 1
#define PROJ_MERCATOR 2
#define PROJ_ROBINSON 3
#define PROJ_MOLLWEIDE 4
#define PROJ_CYLINDRICAL_EQUAL_AREA 5
#define PROJ_AZIMUTHAL_EQUIDISTANT 6
#define PROJ_AZIMUTHAL_HYBRID 7
#define AZIMUTHAL_RIM_BLEND_START 0.42
#define AZIMUTHAL_RIM_BLEND_END 0.98
#define AZIMUTHAL_FAR_BLEND_START 0.68
#define AZIMUTHAL_FAR_BLEND_END 0.98
#define AZIMUTHAL_HYBRID_BLEND 0.43
#define AZIMUTHAL_HYBRID_RIM_BLEND -0.08
#define AZIMUTHAL_HYBRID_FAR_BLEND -0.14

#endif

uniform sampler2D maskTexture;
uniform vec4 textureBounds;
uniform float opacity;

varying vec3 vSpherePosition;

float longitudeToTextureU(float lon) {
  float west = textureBounds.x;
  float east = textureBounds.z;
  float span = east - west;
  float sampleLon = lon;
  if (span <= 0.0) {
    span += 360.0;
    if (sampleLon < west) sampleLon += 360.0;
  } else {
    if (sampleLon < west) sampleLon += 360.0;
    if (sampleLon > east) sampleLon -= 360.0;
  }
  return (sampleLon - west) / span;
}

void main() {
  vec3 spherePosition = normalize(vSpherePosition);
  float lon = degrees(atan(spherePosition.y, spherePosition.x));
  float lat = degrees(asin(clamp(spherePosition.z, -1.0, 1.0)));
  float u = longitudeToTextureU(lon);
  float v = (lat - textureBounds.y) / (textureBounds.w - textureBounds.y);
  if (u < 0.0 || u > 1.0 || v < 0.0 || v > 1.0) {
    discard;
  }
  vec4 texColor = texture2D(maskTexture, vec2(u, v));
  if (texColor.a < 0.01) {
    discard;
  }
  gl_FragColor = vec4(texColor.rgb, texColor.a * opacity);
  #include <colorspace_fragment>
}`